/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const WlResultTypeEnum = {
  EXPIRED: "E",
  PENDING: "P",
  FAILED: "F",
  UNENROLLED: "U",
} as const;

export type WlResultTypeEnum =
  (typeof WlResultTypeEnum)[keyof typeof WlResultTypeEnum];

export type WlResultTypeEnumEnumType = typeof WlResultTypeEnum;
export type WlResultTypeEnumOptional = WlResultTypeEnum;
export type WlResultTypeEnumTrackedI = WlResultTypeEnum;
export type WlResultTypeEnumTracked = WlResultTypeEnum;
export type WlResultTypeEnumMetaI = EnumMetaType<
  WlResultTypeEnumEnumType,
  WlResultTypeEnum
>;
export const WlResultTypeEnumMeta = typeMetaEnum<
  WlResultTypeEnumEnumType,
  WlResultTypeEnum
>("WlResultTypeEnum", WlResultTypeEnum);
export function transformDatesWlResultTypeEnum(model: WlResultTypeEnum) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
